import axios from 'axios';

export const baseUrl =
    `${window.location.origin.indexOf('localhost') < 0
        ? window.location.origin
        : 'https://komiami.zmenu.com.br'
    }/v1`;

const api = axios.create({
    baseURL: baseUrl,
});

api.interceptors.request.use((config) => {
    let token = localStorage.getItem('user_token') || {};

    try {
        token = JSON.parse(token);
    } catch (error) {
        token = {};
    }

    if (
        token.access_token &&
        token.expires_in &&
        token.expires_in > Date.now() / 1000
    ) {
        config.headers = {
            ...config.headers,
            Authorization: 'Bearer ' + token.access_token,
        };
    }

    return config;
});

api.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        /*
        if (error.response.status === 401) {
            localStorage.removeItem('user_token');
            window.location.href('/admin/login');
        }
        */
        return Promise.reject(error);
    },
);

export default api;
